import React from 'react';

export const SurveyAccessPage = () => {
    return (
        <div><a href="/pabs/signin">Click here to proceed to PABS Login</a> <br />
        <a href="/ibs/signin">Click here to proceed to IBS Login</a> <br />
        <a href="https://www.cembenchmarking.com/">Click here to go to CEM Website</a>
        <br /><a href="/logout">Click here to Logout of all services</a></div>
    )
}